import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "London 3",
  "description": "",
  "published": "2007-09-21T00:00:00.000Z",
  "redirect_from": ["/blog/london-3/swizec/154"],
  "categories": "travel",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`yesterday I found out two very important things and one not so important thing. Pubs in London don't seem to serve tea or coffee, just fun-time drinks like beer and such. Another very important thing to know about staying here is that these crazy bastards use some odd three hole power outlets like Americans. How was I supposed to know I won't be able to feed my phone here? The unimportant thing was that it's not wise to travel without a nail clipper because you then have to buy one and it costs you money you could've spent otherwise.`}</p>
    <p>{`Other than that yesterday wasn't too eventful, sure it left my feet in quite some pain ... never teach your feet how to wear boots again by being on them all day straight off ... but I only got to see like three tourist traps. The London Tower, which is quite an amazing piece of medieval fortress thingies and does in fact contain the crown jewels. These are pretty and quite shiny, but they feel a bit tacky.`}</p>
    <p>{`the Tower Bridge was amazing, although the walkways high above the Thames were a bit anticlimatic as I'd hoped I could hang on the fence and stare doom in the face, but rather than that it was all covered up and even bloody carpeted. Not that much fun. However, all was made-up when I reached the engine rooms that gave me quite a nice view on steam engineering. Awesome for steampunk inspiration.`}</p>
    <p>{`Oh I almost forgot, went into the HMS Belfast and ... wow ... must've spent a good two hours in there to see everything it had to offer. Bloody nice. Did make me wonder however how come all the manniquins have heads that are too large for their bodies.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      